import React from "react";
import HeaderCities from "../components/HeaderCities";
import CardboardPickupFAQs from "../components/CardboardPickupFAQs";
import ServicesArea from "../components/ServicesArea";
import UpperFooter from "../components/UpperFooter";
import "../assets/css/services.css";

function Cardboard() {
  return (
    <div>
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta
          name="description"
          content="Need cardboard pickup? We offer fast, eco-friendly cardboard recycling services for homes and businesses. Get a free quote for same-day pickup!"
        />
        <base href="/" />

        <link
          rel="preload"
          as="image"
          href="/assets/img/cardboard-pIckup.webp"
          type="image/webp"
        />
        <link
          rel="canonical"
          href="https://junkdroid.com/services/cardboard-pickup/"
        />

        <title>Same-Day Cardboard Pickup | Junk Droid</title>
        <link rel="icon" href="assets/img/favicon.png" />
      </head>
      <>
        <HeaderCities />
        {/* ================== Hero Section Start HERE =========================  */}
        <div className="container-fluid madeesay-sec">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-12">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Home</a>
                    </li>
                    <li className="breadcrumb-item">
                      <a href="#">Services</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Cardboard Pickup
                    </li>
                  </ol>
                </nav>
                <h1>
                  Fast & Eco-Friendly <span>Cardboard Pickup</span>
                </h1>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <div className="inner-img">
                  <img
                    src="/assets/img/cardboard-pIckup.webp"
                    alt="cardboard"
                  />
                </div>
                <p>
                  Too much cardboard? Junk Droid offers fast, reliable cardboard
                  pickup for homes & businesses. Book same-day pickup and clear
                  the clutter effortlessly!
                </p>
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6 booking-btn">
                    <a href="tel:4085397261">
                      <button type="button" className="btn">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-telephone-fill"
                          viewBox="0 0 16 16"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"
                          />
                        </svg>{" "}
                        &nbsp; CALL NOW
                      </button>
                    </a>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-6 rate-sect">
                    <h4>Rated 5.0 on Google</h4>
                    <div className="rating-sec">
                      <span>5.0</span> &nbsp;&nbsp;
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill ms-0"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        class="bi bi-star-fill"
                        viewBox="0 0 16 16"
                      >
                        <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 desk-img">
                <img src="/assets/img/cardboard-pIckup.webp" alt="cardboard" />
              </div>
            </div>
          </div>
        </div>
        {/* ================== Hero Section End HERE =========================  */}
        {/* ================== First  Section Start HERE =========================  */}
        <hr />
        <div className="container-fluid overview-sec">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="major-heading">
                  Bulk Cardboard Pickup & <span>Disposal Services</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  Junk Droid provides efficient and eco-friendly cardboard
                  disposal services, ensuring that your cardboard waste is
                  properly handled. We make it easy to recycle cardboard and
                  minimize the environmental impact by working with recycling
                  centers to keep cubic yards of landfill space clear of
                  unnecessary waste.
                </p>
                <p className="service-description">
                  Our friendly team takes care of everything—from heavy lifting
                  to transporting your extra cardboard to the proper recycling
                  waste management. Whether you're a business owner, a renter,
                  or a real estate agent, we ensure a hassle-free experience.
                </p>
                {/* ============ */}
                <h3>
                  Why Choose Junk Droid for <span>Cardboard Box Pickup?</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  <li>
                    <span>Convenient & Fast:</span>&nbsp;We prioritize waste
                    management, working with recycle centers to ensure all
                    materials are turned into new paper products instead of
                    ending up in landfills.
                  </li>
                  <li>
                    <span>Affordable & Transparent Pricing:</span>&nbsp;With
                    instant upfront pricing and detailed information on costs,
                    you’ll never be surprised by hidden fees.
                  </li>

                  <li>
                    <span>Flexible Payment Options:</span>&nbsp;We accept credit
                    cards, debit, Zelle, checks, and cash for your convenience.
                  </li>
                </p>
                {/* ============ */}
                <h3>
                  How It <span>Works</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>
                  <li>
                    <span>Schedule Pickup:</span>&nbsp;Choose a time that works
                    for you—same-day, next-day pickup, or curbside pickup
                    options available.
                  </li>
                  <li>
                    <span>Get a Free Quote:</span>&nbsp;Get an estimate based on
                    your cardboard packaging volume.
                  </li>
                  <li>
                    <span>We Handle the Heavy Lifting:</span>&nbsp;Our team
                    arrives, collects your cardboard waste, and transports it
                    for responsible disposal.
                  </li>
                  <li>
                    <span>Eco-Friendly Recycling:</span>&nbsp;We drop off
                    recyclable materials at designated recycling centers,
                    ensuring your cardboard removal services support
                    sustainability.
                  </li>
                  <li>
                    <span> Flexible Payment Options:</span>&nbsp;We accept
                    credit cards, Zelle, cash, and more!
                  </li>
                </p>
                {/* ========= */}
                <div className="col-md-12 overview-sec service-desc book-descr">
                  <h3>
                    Book Your Cardboard <span>Pickup Today!</span>
                  </h3>
                  <div className="sliderline-svg">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={64}
                      height={4}
                      viewBox="0 0 64 4"
                      fill="none"
                    >
                      <path
                        d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                        fill="#60BDFF"
                      />
                    </svg>
                  </div>
                  <p>
                    Say goodbye to cardboard clutter with Junk Droid’s easy and
                    affordable cardboard recycling services. Contact us now for
                    same-day pickup and great service!
                  </p>
                </div>
                {/* ===================================================================================0 */}
                <h3>
                  Service <span>Area</span>
                </h3>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
                <p>We proudly serve homes and properties in:</p>
                {/* ===================================================================================0 */}
                <ServicesArea />
                {/* ============ */}
              </div>
            </div>
          </div>
        </div>
        {/* ================== First  Section End HERE =========================  */}

        {/* ================== FAQ's Section Start HERE =========================  */}
        <div className="container faq-sec">
          <div className="row">
            <div className="col-md-12">
              <div>
                <h2 className="pt-0 pb-2">
                  Cardboard Pickup <span>FAQs</span>
                </h2>
                <div className="sliderline-svg">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={64}
                    height={4}
                    viewBox="0 0 64 4"
                    fill="none"
                  >
                    <path
                      d="M56.7799 0H7.2201C3.23255 0 0 0.895419 0 1.99999C0 3.10456 3.23255 4 7.2201 4H56.7799C60.7675 4 64 3.10456 64 1.99999C64 0.895419 60.7675 0 56.7799 0Z"
                      fill="#60BDFF"
                    />
                  </svg>
                </div>
              </div>
              <CardboardPickupFAQs />
            </div>
          </div>
        </div>
        <UpperFooter />
      </>
    </div>
  );
}

export default Cardboard;
